import { gsap } from 'gsap';
import { pauseAllPlayers, getPlayerById } from '@components/ui/vimeo-player/vimeo-player';

/**
 * Helpers.
 */
const openOverlay = (overlay) => {
  const openTimeline = gsap.timeline();
  openTimeline
    .to(overlay, {
      autoAlpha: 1,
      display: 'block',
      duration: 0.2,
    })
    .fromTo(overlay.querySelector('.vimeo-player'), {
      y: '50',
      autoAlpha: 0,
    }, {
      y: '0',
      autoAlpha: 1,
      duration: 0.2,
      onComplete() {
        gsap.set(document.body, { overflow: 'hidden' });
        // If there's a video, play it!
        const videoWrap = overlay.querySelector('.vimeo-player__iframe-wrap');
        const videoPlaceholder = overlay.querySelector('.vimeo-player__placeholder');
        if (videoWrap) {
          const vimeoPlayer = getPlayerById(videoWrap.getAttribute('id'));

          // If the player is already initialized, use it.
          if (vimeoPlayer) {
            vimeoPlayer.play();
          } else {
            // Otherwise, trigger the element to load Vimeo.
            videoPlaceholder.click();
          }
        }
      },
    });
};
const closeOverlay = (overlay) => {
  pauseAllPlayers();
  const closeTimeline = gsap.timeline();
  closeTimeline
    .to(overlay.querySelector('.vimeo-player'), {
      y: '+=50',
      autoAlpha: 0,
      duration: 0.2,
    })
    .to(overlay, {
      autoAlpha: 0,
      display: 'none',
      duration: 0.2,
      onComplete() {
        gsap.set(document.body, { overflow: 'auto' });
      },
    });
};
const closeOverlays = (vimeoOverlays) => {
  Array.from(vimeoOverlays).forEach((overlay) => {
    closeOverlay(overlay);
  });
};

/**
 * Initialize on page load.
 */
const vimeoOverlayTriggers = document.querySelectorAll('[data-vimeo-overlay-trigger]');
const vimeoOverlays = document.querySelectorAll('.vimeo-overlay');

// Intialize overlay close events.
Array.from(vimeoOverlays).forEach((overlay) => {
  const overlayClose = overlay.querySelector('.vimeo-overlay__close');
  overlayClose.addEventListener('click', (e) => {
    e.preventDefault();
    closeOverlay(overlay);
  });
});

// Close overlays on escape key.
document.addEventListener('keydown', (e) => {
  if (e.key === 'Escape') {
    closeOverlays(vimeoOverlays);
  }
});

// Initialize overlay trigger events.
Array.from(vimeoOverlayTriggers).forEach((trigger) => {
  const correspondingOverlay = document.getElementById(`vimeo-overlay-${trigger.getAttribute('data-vimeo-overlay-trigger')}`);
  if (correspondingOverlay) {
    trigger.addEventListener('click', (e) => {
      e.preventDefault();
      openOverlay(correspondingOverlay);
    });
  }
});
